export const ACCOUNTS_DATA_FIELDS_ACTION = 'ACCOUNTS_DATA_FIELDS_ACTION';

export const RESOURCES_LIMITS_PREFIX = '/@resource_limits/';

export const RESOURCES_USAGE_PREFIX = '/@resource_usage/';

export const RECURSIVE_RESOURCES_USAGE_PREFIX = '/@recursive_resource_usage/';

export const TOTAL_CHILDREN_RESOURCE_LIMIT = '/@total_children_resource_limits/';

export const ALLOW_CHILDREN_LIMIT_OVERCOMMIT = '/@allow_children_limit_overcommit';
